import { LoadingButton } from "@mui/lab";
import { useFormActions, useFormState, useScopedField } from "@ngt/forms-core";
import { FC, useCallback } from "react";

interface INextButtonProps {
    onClick: () => void;
    index: number;
    setComplete: React.Dispatch<React.SetStateAction<Record<number, boolean>>>;
}

const NextButton: FC<INextButtonProps> = ({ onClick }) => {
    const {state: {value: alreadyRegistered}} = useScopedField<boolean>("alreadyRegistered", {value: true});
    const {fields, errors, validating} = useFormState({errors: true, fields: true, validating: true})
    const {setTouched} = useFormActions()

    const onNext = useCallback((e: React.MouseEvent) => {

        const hasErrors = fields.reduce((a, b) => {
            if(a)
                return a;
            return errors[b]?.length > 0;
        }, false);

        if (alreadyRegistered) {
            return;
        }

        if(!hasErrors){
            onClick();
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
        else{
            onClick();

            setTouched((current) => {
                fields.forEach(path => {
                    current[path] = true;
                });
    
                return current;
            });

            document.querySelector('.error-normal')?.scrollIntoView({behavior: 'smooth', block: 'center'});
        }
    }, [errors, fields, onClick, alreadyRegistered, setTouched])
    


    return (
        <LoadingButton variant="contained" 
            onClick={onNext}
            sx={{
                float: "right",
                marginTop:"20px",
                //backgroundColor: "#76CED9",
                //fontWeight: "bold",
                
            }}
            disabled={!!alreadyRegistered}
            loading={validating}
            color="tertiary"
        >
            Next
        </LoadingButton>
    )
}

export default NextButton;